export default __webpack_public_path__ + "static/media/woddiniBanner.a74ef84a.jpeg";